import React from "react";
import PdfToOfficeConverter from "../../components/PdfToOfficeConverter";

const PdfToWord = () => (
  <PdfToOfficeConverter
    target="Word"
    title="Convert PDF to Word"
    description="Turn your PDF into an editable DOCX file."
  />
);

export default PdfToWord;
